const theme = {
  colors: {
    background: '#ffffff',            
    default: '#212529',               
    heading: '#2d465e',                
    accent: '#f59e0b',                 
    surface: '#ffffff',               
    contrast: '#ffffff',              

    nav: '#212529',                   
    navHover: '#0d83fd',              
    navMobileBg: '#ffffff',           
    navDropdownBg: '#ffffff',         
    navDropdown: '#212529',         
    navDropdownHover: '#0d83fd',     

    lightBackground: '#f3f9ff',
    darkBackground: '#0d83fd',
    darkSurface: '#409dfd',
    darkText: '#ffffff',

    primary: '#27227d',      
    primaryText: '#f59e0b',   
    warning: '#f59e0b',
    warningDark: '#d97706',
    dark: '#27272a',
    textSecondary: '#64748b',
    border: '#e2e8f0',
    white: '#ffffff',
  },
  fonts: {
    default: '"poppins", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    heading: '"montserrat", sans-serif',
    nav: '"poppins", sans-serif',
  },
  behavior: {
    scrollSmooth: true,
  },
};

export default theme;
